import * as o from "react";
import e from "../lib/IconBase.es.js";
import a from "../defs/Prohibit.es.js";
const r = o.forwardRef((t, i) => /* @__PURE__ */ o.createElement(e, { ref: i, ...t, weights: a }));
r.displayName = "ProhibitIcon";
const s = r;
export {
  s as Prohibit,
  r as ProhibitIcon
};
